import { FC, useState, useEffect } from 'react';

import { Step1 } from './Steps/Step1';
import { Step2 } from './Steps/Step2';

interface TrainingProps {
  step: number;
  setStep: (value: number) => void;
  totalPoints: number;
  userToken: string;
}

const Training: FC<TrainingProps> = ({
  step,
  setStep,
  totalPoints,
  userToken,
}) => {
  const [isTrainingCompleted, setIsTrainingCompleted] = useState<boolean>();

  useEffect(() => {
    if (userToken) {
      fetch(`https://admin.znatok.jti-games.dev.familyagency.ru/api/mini-game/status`, {
        headers: {
          UserToken: userToken,
        },
      })
        .then((response) => response.json())
        .then(({ data }) => setIsTrainingCompleted(data.miniGameStatus));
    }
  }, [userToken]);

  return (
    <>
      {step === 1 && (
        <Step1
          setStep={setStep}
          totalPoints={totalPoints}
          isTrainingCompleted={isTrainingCompleted}
          userToken={userToken}
        />
      )}
      {isTrainingCompleted && step === 2 && (
        <Step2 setStep={setStep} userToken={userToken} />
      )}
    </>
  );
};

export default Training;
